import { useNavigate } from 'react-router';
import {
  useProposalState,
  useAuthState,
  useHistoryState,
} from '@src/shared/hooks';
import { addToHistory, removeFromHistory } from '@src/shared/zustand';
import { observability } from '@src/config';

export const useNavigationHandlers = () => {
  const { proposal } = useProposalState();
  const { token } = useAuthState();
  const { history } = useHistoryState();
  const navigation = useNavigate();

  const genericNavigate = (uri: string, notSetHistory?: boolean) => {
    if (!notSetHistory) addToHistory(uri);

    observability.navigation(uri);

    navigation(uri, { viewTransition: true });
  };

  return {
    goToLoading: () => {
      if (proposal) {
        genericNavigate('/loading');
      } else {
        genericNavigate('/error');
      }
    },
    goBack: () => {
      if (!history?.length) return;
      const last = history[history?.length - 1];
      removeFromHistory(last);
      const lastHistory = history[history?.length - 2];

      if (!lastHistory) {
        genericNavigate(`/${proposal.proposalId}/proposal/${token}`);
      } else {
        navigation(history[history?.length - 2]);
      }
    },
    toHome: (notSetHistory?: boolean) => {
      if (proposal) {
        genericNavigate(
          `/${proposal.proposalId}/proposal/${token}`,
          notSetHistory
        );
      } else {
        genericNavigate('/error');
      }
    },
    toConfirmed: () => genericNavigate('/proposal/confirmed'),
    toFaq: () => genericNavigate('/faq'),
    toCCB: () => genericNavigate('/terms/ccb'),
    toError: () => genericNavigate('/error'),
    toErrorSession: () => genericNavigate('/error/session'),
    toTicket: () => genericNavigate('/ticket'),
    toErrorEmail: () => genericNavigate('/error/email-invalid'),
    toTerms: () => genericNavigate('/terms/terms-and-conditions'),
    toPrivate: () => {
      window.open(
        'https://www.pagol.com.br/politica-de-privacidade/politica-de-privacidade-do-site-pagol',
        '_blank'
      );
    },
    toEmailValidation: () => genericNavigate('/email-validation'),
    toReprovedByIdwall: () => genericNavigate('/error/reproved'),
    toTimeoutIdwall: () => genericNavigate('/error/timeout'),
  };
};
